import { CapType, ICap, IDollarCap } from "./budget";

export const CAP_TYPE_OPTIONS = [
  { value: "NONE", label: "None" },
  { value: "DAILY", label: "Daily" },
  { value: "HOURLY", label: "Hourly" },
];

export const CAP_BUDGET_LABEL = {
  HOURLY: "Hourly spend cap",
  DAILY: "Daily spend cap",
  NONE: "Spend cap",
};

export const typeToLabel = {
  [CapType.DAILY]: "/ day",
  [CapType.HOURLY]: "/ hr",
};

export const getCapLabel = (cap?: ICap | IDollarCap) => {
  if (!cap?.value) return undefined;
  return typeToLabel[cap.type];
};
